module.exports = __webpack_public_path__ + "static/media/file.a81ea69d.svg";